import {
    OBTENER_DEVICE_PROFILES,
    AGREGAR_MARCA,
    ELIMINAR_MARCA,
    ACTUALIZAR_DEVICE_PROFILE,
    MARCA_ERROR,
    MARCA_OK,
    MARCA_ACTUAL,
    OBTENER_DEVICE_PROFILE,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_DEVICE_PROFILES:
            return {
                ...state,
                deviceProfiles: action.payload
            }
        case MARCA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MARCA_OK:
            return {
                ...state,
                mensaje: action.payload
            }
        case AGREGAR_MARCA:
            return {
                ...state,
                marca:action.payload,
                marcas: [...state.marcas, action.payload],
                formulario: false,
                errorformulario: false
            }
        case MARCA_ACTUAL:
            return {
                ...state,
                marca: state.marcas.find(marca => marca._id === action.payload)
            }
        case ELIMINAR_MARCA:
            return {
                ...state,
                marcas: state.marcas.filter(marca => marca._id !== action.payload),
                marca: null
            }
        case ACTUALIZAR_DEVICE_PROFILE:
            return {
                ...state,
                //deviceProfiles: state.marcas.map(deviceProfile => deviceProfile.id === action.payload.id ? action.payload : deviceProfile),
                deviceProfile: action.payload
            }
        case OBTENER_DEVICE_PROFILE:
            return {
                ...state,
                deviceProfile: action.payload
            }
        default:
            return state;
    }
}